'use strict'; // @MAJOR can be replaced by native Array#findIndex when we change support

require("core-js/modules/es6.array.is-array");

module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return -1;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return i;
    }
  }

  return -1;
};